import mapboxgl from 'mapbox-gl';

export function getUnpaddedBounds(map) {
  let canvas = map.getCanvas();

  let sw = map.unproject([0, canvas.clientHeight]);
  let ne = map.unproject([canvas.clientWidth, 0]);

  return new mapboxgl.LngLatBounds(sw, ne);
}
